import { render, staticRenderFns } from "./VPageCtn.vue?vue&type=template&id=0889140e&"
import script from "./VPageCtn.vue?vue&type=script&lang=js&"
export * from "./VPageCtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports